<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">Edit Personal Device</v-card-title>

    <v-card-text>

        <v-form>
            <v-text-field
                label="Label"
                v-model="label"
                autofocus
                autocomplete="off"
            />

            <v-text-field
                label="Phone Number"
                v-model="endpoint"
                autocomplete="off"
            />

            <v-checkbox
                label="Accept SMS (text messages)"
                v-model="accept_sms"
            />

        </v-form>

    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
            :disabled="!isValid()"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const E164 = require('@/js/E164.js');

const empty_device = {
    'endpoint' : null,
    'label': null,
    'accept_sms': null,
}

export default {
    data() {
        return {
            dialog: false, 

            endpoint: null,
            label: null,
            accept_sms: true,
            index: -1,
        }
    },

    methods: 
    {
        showDialog(index, device) 
        {
            if ( index == null )
                this.index = -1;
            else    
                this.index = index;

            if ( device != null )
            {
                this.endpoint = E164.prettyPrintUsPhoneNumber(device.endpoint);
                this.label = device.label;
                this.accept_sms = device.accept_sms;
            }
            else
            {
                this.endpoint = null;
                this.label = null;
                this.accept_sms = true;
            }
            
            this.dialog = true;
        },

        isValid()
        {
            if ( this.endpoint == null ) return false;
            if ( E164.createEndpointFromUSPhoneNumber(this.endpoint,null) == null ) return false;
            if ( this.label == null || this.label.trim().length == 0 ) return false;

            return true;
        },
        
        onOk()
        {
           this.dialog = false;

            let device = {
                'index': this.index,
                'endpoint': E164.createEndpointFromUSPhoneNumber(this.endpoint,null),
                'label' : this.label.trim(),
                'accept_sms' : this.accept_sms,
            };

           this.$emit('ok', device);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>